import { SettingsViewInitEpic } from './SettingsViewInitEpic';
import { SettingsViewOnRouteToSettings } from './SettingsViewOnRouteToSettings';
import { SettingsViewOnChangeActiveTab } from './SettingsViewOnChangeActiveTab';

export const rootSettingsViewEpics = [
  SettingsViewInitEpic,
  SettingsViewOnRouteToSettings,
  SettingsViewOnChangeActiveTab,
];
